import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar, Button } from 'react-bootstrap';
import { get, pick } from 'lodash';
import classNames from 'classnames';
import { hashStr } from '../../utils/utilities';
import Loading from '../../components/shared/Loading'

class ActionBar extends React.Component {
    constructor(props) {
        super(props);

        this.dirtHash = {};

        this.props.activators.map((activator, idx) => {
            let { dirtValues } = activator;
            if (dirtValues) {
                if (Array.isArray(dirtValues)) {
                    dirtValues = activator.dirtValues.map(value => {
                        if (Array.isArray(value)) {
                            return value.sort();
                        }
                        return value;
                    });
                }
                this.dirtHash[idx] = hashStr(JSON.stringify(dirtValues));
            }
        });
    }

    checkDirt(values, idx) {
        return this.dirtHash[idx] !== hashStr(JSON.stringify(values));
    }

    render() {
        const {
            activators,
            isBound,
            quoteDrafted,
            isActiveBrokerage,
            submission,
            manuallySetPricing,
            isLoading,
            enableSaveManually,
            pricingValues,
            isUnderwriter,
            isRatingsLoading
        } = this.props;
        let isBinded;
        !!isBound ? isBinded = isBound : isBinded = false

        const basePremium = manuallySetPricing && isUnderwriter && Object.hasOwn(pricingValues, 'basePremium')
            ? pricingValues.basePremium
            : submission.ratings[submission.type].basePremium;
        let cdRatedBasePremium;
        if (!!submission.ratings) {
            cdRatedBasePremium = submission.ratings && submission.ratings.options && submission.ratings.options.baseCoverageOption && submission.ratings.options.baseCoverageOption[submission.coverages.gl.base] ? submission.ratings.options.baseCoverageOption[submission.coverages.gl.base] : submission.ratings.options.basePremium
        }

        /**
         * Only an UW can enter a credit and submit, so only check the minCredit for the UW. If the 
         * min credit ever changes in the future to a number greater than 0, we may want to check it
         * for the Broker. In which case we can check if the basePremium is greater than 0 and then calc the
         * minCredit. (Please note, if a Broker visits the pricing UI after an UW sets it to manuallySet,
         * manuallySetPricing will be true and the basePremium is set to 0 the 2nd time a Broker submits a
         * referred submission. So we would not check for minCredit on subsequent submits.)
         */
        const minCredit = manuallySetPricing === true && isUnderwriter && !!cdRatedBasePremium && (basePremium / cdRatedBasePremium <= 0);
        const transactionInIP = manuallySetPricing === true && submission.transactionStatus === 'IP';
        return (
            <ButtonToolbar className="action-bar">
                {activators.map((activator, idx) => {
                    let isDirty = (this.checkDirt(activator.dirtValues, idx) || quoteDrafted === 'true' || enableSaveManually === true || (transactionInIP && activator.label !== 'Update Excess') || activator.alwaysActive) && activator.disableManually !== true;
                    if (
                        typeof activator.condition === 'function' &&
                        activator.condition(activator.data) === 0
                    ) {
                        return null;
                    }
                    if (((submission.type == "ocp") && isBound) || !isActiveBrokerage || minCredit) isDirty = false
                    if (isRatingsLoading && !activator.alwaysActive) isDirty = false
                    return (
                        <Button
                            key={`action-button-${idx}`}
                            onClick={isDirty ? activator.handler : null}
                            disabled={!isDirty}
                            bsStyle={classNames(activator.style || 'default', activator.additionalStyle)}

                        >
                            {!activator.isLoading && activator.label}
                            {activator.isLoading && <Loading classes="loading" width="20px" marginLeft="35%" />}
                        </Button>
                    );
                })}
            </ButtonToolbar>
        );
    }
}

ActionBar.propTypes = {
    activators: PropTypes.array
};

export default ActionBar;
